import React from 'react';
import ReactDOM from 'react-dom/client';
import './Styles/style.css';
import App from './App';
import 'antd/dist/antd.css';

import AuthProvider from './Stores/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
